import React from "react";
import { View } from "react-native";
import Text from "../Text";
import MarkdownText from "../MarkdownText";
import { Container, Title, Body, Caption, Pin } from "./styles";

type ArticleProps = {
    type?: "default" | "safeMode" | "reverse";
    title?: string;
    body?: string;
    caption?: string;
};

const Article = ({ type, title, body, caption }: ArticleProps) => {
    if (type === "safeMode") {
        return (
            <Container isReverse>
                {title && (
                    <Title>
                        <Text type="h1">{title}</Text>
                    </Title>
                )}
                {body && (
                    <Body>
                        <MarkdownText>{body}</MarkdownText>
                    </Body>
                )}
                <Pin>
                    <Text type="h6">0000</Text>
                </Pin>
                {caption && (
                    <Caption>
                        <MarkdownText>{caption}</MarkdownText>
                    </Caption>
                )}
            </Container>
        );
    } else if (type === "reverse") {
        return (
            <Container isReverse>
                {title && <Text type="h1">{title}</Text>}
                {body && <MarkdownText>{body}</MarkdownText>}
                {caption && (
                    <Caption>
                        <MarkdownText>{caption}</MarkdownText>
                    </Caption>
                )}
            </Container>
        );
    }
    return (
        <Container>
            {title && (
                <Title>
                    <Text type="h1">{title}</Text>
                </Title>
            )}
            {body && (
                <View style={{ marginBottom: 12 }}>
                    <MarkdownText>{body}</MarkdownText>
                </View>
            )}
            {caption && <MarkdownText>{caption}</MarkdownText>}
        </Container>
    );
};

export default Article;
